// src/utils/fileUrl.js
import API_BASE_URL from '../config/api';

/**
 * แปลง ref ของไฟล์ที่เก็บใน DB ให้เป็น URL ที่ใช้งานได้
 * - 'gdrive:<fileId>'        -> /api/storage/file/:fileId (proxy จาก Google Drive)
 * - 'http(s)://...'           -> คืนค่าเดิม (URL เต็มแล้ว)
 * - ชื่อไฟล์ธรรมดา (local)    -> /uploads/<folder>/<ref>
 * @param {string} ref  ref ที่เก็บใน DB
 * @param {string} folder  โฟลเดอร์ local (default 'monks' สำหรับรูปพระ)
 */
export function getFileUrl(ref, folder = 'monks') {
  if (!ref) return null;

  if (ref.startsWith('gdrive:')) {
    return `${API_BASE_URL}/api/storage/file/${ref.replace('gdrive:', '')}`;
  }

  if (ref.startsWith('http://') || ref.startsWith('https://')) {
    return ref;
  }

  return `${API_BASE_URL}/uploads/${folder}/${ref}`;
}

export default getFileUrl;

